import React, { Suspense } from 'react'
import SkelLogin from './SkelLogin'
const LoginPageBase = React.lazy(() => import('./Login'))

export const LoginPage = () => (
  <Suspense fallback={<SkelLogin />}>
    <LoginPageBase />
  </Suspense>
)
